import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as style from './Spacing.style';
export const Spacing = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    margin = 0,
    padding = 0,
    dataRef,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    $margin: margin,
    $padding: padding,
    ref: ref,
    "data-ref": dataRef
  }, rest, {
    $_css: style.base
  }), children);
});
export default Spacing;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Spacing___StyledDiv",
  componentId: "sc-l88upr-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Spacing.js.map